// @ts-nocheck
export default defineNuxtRouteMiddleware(async (to, from) => {
  const { isAuthenticated, refreshIdentity } = useSanctumAuth()

  refreshIdentity().then(() => {
    if (isAuthenticated.value) {
      const isInfluenceriOS = useState('isInfluenceriOS', () => false)
      const isInfluencerAndroid = useState('isInfluencerAndroid', () => false)

      const isInfluencer = computed(() => isInfluenceriOS.value || isInfluencerAndroid.value || to.fullPath.includes('influ') || from.fullPath.includes('influ'))
      const loggedInRoute = computed(() => isInfluencer.value ? '/influenciador/link-viral' : '/app/dashboards/home')

      return navigateTo(loggedInRoute.value, {
        open: {
          target: '_self',
        },
      })
    }
  }).catch(() => {})
})
